export const ar = {
  lang: "English",
  video: {
    howToUse: "كيفية استخدام جرين ماتر",
  },
  auth: {
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
    phone: "رقم الموبايل",
    name: "اسم المستخدم",
    firstName: "الاسم الأول",
    middleName: "الاسم الأوسط",
    lastName: "الاسم الأخير",
    email: "البريد الإلكتروني",
    accept: "الموافقة على",
    rememberMe: "تذكرني",
    termsAndConditions: "الشروط والأحكام",
    noAccount: "ليس لديك حساب؟",
    withAccount: "لديك حساب بالفعل؟",
    requiredName: "اسم المستخدم مطلوب",
    requiredFirstName: "الاسم الاول مطلوب",
    requiredSecondName: "الاسم الاوسط مطلوب",
    requiredThirdName: "الاسم الاخير مطلوب",
    invalidName: "من فضلك ادخل اسم صحيح",

    requiredMobile: "رقم الموبايل مطلوب",
    invalidMobile: "من فضلك ادخل رقم موبايل صحيح",
    requiredEmail: "البريد الإلكتروني مطلوب",
    invalidEmail: "من فضلك , أدخل بريد إلكتروني صحيح",
    verifyOTP: "رمز التأكيد",
    resendCode: "إعادة إرسال الكود",

    idNumber: "الرقم القومي",
    requiredIdNumber: "الرقم القومي مطلوب",
    invalidIdNumber: "من فضلك , أدخل رقم قومي صحيح",

    salesId: "معرّف مندوب المبيعات",
    salesIdHint: "أدخل المعرّف الذي زوّدك به مندوب المبيعات (إن وُجد).",
    invalidSalesId:
      "معرّف مندوب المبيعات يجب أن يكون 6 أحرف أو أرقام بالإنجليزية فقط.",
    weSent: "تم إرسال رمز التحقق إلى بريدك الإلكتروني",
    sendCodeToMobile: "ارسال الكود عبر الموبايل",
    sendCodeToEmail: "ارسال الكود عير البريد الالكتروني",
    codeWillBeSentToEmail:
      "سيتم إرسال رمز التحقق إلى البريد الإلكتروني المرتبط بهذاالهاتف المحمول.",
    signInWithEmail: "تسجيل الدخول باستخدام البريد الإلكتروني",
  },
  nav: {
    home: "الرئيسية",
    about: "عن الشركة",
    pendingOrders: "الطلبات المعلقة",
    pendingWithdrawals: "عمليات السحب المعلقة",
    balance: "الرصيد",
    buyers: "المشتري",
    signout: "تسجيل الخروج",
    contactUs: "تواصل معنا",
    terms: "الشروط والأحكام",
    profile: "الحساب الشخصي",
    bidders: "المزايدين",
    luckyHours: "أسعار مخفضة",
    myGroups: "مجموعاتي",
    store: "المتجر",
    more: "المزيد",
    auctionRequests: "طلبات المزاد",
    buyAndSupply: "شراء وتوريد",
    merchant: "التاجر",
    concierge: "خدمة الكونسيرج",
    partnership: "الشراكات",
    rentSpace: "مخزن للتأجير",
    received: "تأكيد الاستلام",
    tooltip:
      "من حجز الفنادق والمطاعم لحد التسوّق الشخصي عشان تختار هدايا مميزة… إحنا بنسهّل عليك كل تفصيلة، مهما كانت صغيرة.",
  },
  home: {
    greenMatter: "جرين ماتر",
    description: "شريكك في إعادة تدوير الألمنيوم بشكل مستدام.",
    descriptionB:
      "يتم تحديد سعر كانز الألومنيوم عن طريق المزاد، بناءً على العرض والطلب في السوق.",
    buyItem: "شراء هذا المنتج",
    exchangeItem: "استبدال هذا المنتج",
    extendItem: "تمديد هذا المنتج",
    available: "متاح في المتجر",
    pricePerKilo: "جنيه/كيلو",
    purchaseRequest: "طلب شراء",
    emptyItems:
      "تم بيع جميع خردة الألومنيوم. يرجى التحقق لاحقا من العناصر المضافة",
    itemModal: {
      available: "متاح",
      kilo: "كيلو",
      kilos: "كيلو",
      type: "حدد نوع الطلب",
      enterQuantity: "حدد الكمية",
      enterUnit: "حدد الوحده",
      totalPrice: "السعر الكلى",
      totalQuantity: "الكمية الكلية",
      payment: "حدد طريقة الدفع",
      quantity: "الكمية",
      unit: "الوحده",
      priceUnit: "جنيه",
      requiredType: "من فضلك حدد نوع الطلب",
      requiredQuantity: "من فضلك حدد الكمية",
      invalidQuantity: "من فضلك ادخل كمية صحيحة",
      requiredPayment: "من فضلك حدد طريقة الدفع",
      quantityError: "الكمية غير متاحة",
      taxes: "يضاف 2.5% ضريبة على السعر الكلي",
      walletNumber: "رقم محفظة الهاتف",
      requiredWallet: "من فضلك، ادخل رقم محفظة الهاتف",
      invalidWallet: "من فضلك، ادخل رقم محفظة هاتف صحيح",
      productPriceChanged:
        "مع الاسف, لقد تغير للتو سعر هذا المنتج و أصبح السعر",
      pressOk: "للأستمرار اضفط موافق",
      ok: "موافق",
      managementFees: "مصاريف ادارية",
      bankTransfer: {
        title: "بيانات التحويل البنكي",
        description:
          "يرجى تحويل المبلغ الإجمالي إلى الحساب البنكي التالي والاحتفاظ بإيصال التحويل:",
        bankName: "اسم البنك",
        accountName: "اسم الحساب",
        accountNumber: "رقم الحساب",
        branchName: "الفرع",
        iban: "رقم IBAN",
        continue: "متابعة إلى الفاتورة",
        back: "رجوع",
      },
      message:
        "يجب سداد جميع المدفوعات فقط إلى الحساب البنكي الرسمي للشركة أو نقدًا داخل مقر الشركة من خلال فريق الشؤون المالية. ولا تتحمل الشركة أي مسؤولية عن أي مدفوعات يتم سدادها خارج هذه القنوات.",
    },
    exchangeModal: {
      heading: "استبدال المنتج",
      selectOrderType: "اختر نوع الطلب",
      selectBalance: "اختر من رصيدك",
      totalWeight: "الوزن الكلي",
      totalPrice: "السعر الكلي",
      enterTotalWeight: "ادخل الوزن",
      quantityLessThan1: "الحد الأدنى للشراء هو",
      notAvailableInStore: "لا يوجد مخزون متاح للكمية التي سيتم تبادلها",
      purchaseAmount: "قيمة الشراء ستكون",
      purchasePrice: "سعر الشراء",
      deduct: "اخصم من الرصيد",
      invalidQuantity: "ادخل كمية صحيحة",
      invalidQuantityNotEnoughBalance: "رصيدك غير كافي",
      weight: "الوزن",
      price: "السعر",
      exchange: "استبدال",
      exchangeItem: "استبدل المنتج",
      noBalance: "!ليس لديك رصيد صالح للاستبدال",
      kg: "كجم",
      le: "جنيه",
      totalPriceAfterCommissionDeduction: "السعر الكلي بعد خصم العمولة",
    },
    extendModal: {
      heading: "تمديد المنتج",
      extend: "تمديد",
      noBalance: "ليس لديك رصيد صالح للتمديد!",
      extensionFeeNotice: "بتمديد الفترة، سيتم تطبيق رسوم تخزين بنسبة 1٪",
      sellPrice: "سعر البيع",
    },
  },
  about: {
    about: "عن الشركة",
    greenMatter: "جرين ماتر",
    firstSection: {
      1: `مرحباً بكم في "جرين ماتر"، المنصة الرائدة حيث يمكن للأفراد والشركات الدخول لشراء وبيع وتخزين خردة الألومنيوم بناءً على عمولة.`,
      2: `منذ تأسيسها في عام ٢٠١٢، أصبحت "جرين ماتر" المنصة الرقمية التي تمكّنك بسهولة من بيع وشراء علب الألومنيوم سواء كنت تاجراً، أو مشغّل أفران، أو مصنعاً للألومنيوم. يقوم نظام التسعير لدينا على ديناميكية العرض والطلب الفوري، إضافةً إلى مزادات تنافسية بين المشترين.`,
    },
    secondSection: {
      1: "نحن ملتزمون بتوفير تجربة سلسة وفعالة لجميع مستخدمينا. سواء كنت مورداً يبحث عن التخلص من خردة الألومنيوم الخاصة بك أو مشترياً يبحث عن مواد عالية الجودة، تقدم منصتنا واجهة سهلة الاستخدام تبسط العملية بأكملها. خيارات البحث والتصفية المتقدمة لدينا تسمح لك بالعثور على ما تحتاج إليه بالضبط، بينما يضمن نظام الدفع الآمن لدينا عملية تعامل سلسة وموثوقة.",
      2: `في "جرين ماتر"، تتجاوز جهودنا الحد من الأثر البيئي لإنتاج الألومنيوم؛ نحن ملتزمون بصياغة مستقبل أفضل للجميع.`,
    },
    joinSection: {
      title: "رسالتنا:",
      description: `تهدف "جرين ماتر" إلى تحويل صناعة خردة الألومنيوم بمجتمع من الأفراد ذوي الأفكار المتشابهة الذين ملتزمون باتخاذ خيارات مستدامة ودفع التحولات الإيجابية في البيئة والاقتصاد والمجتمع.`,
    },
    videoSection: {
      title: "رؤيتنا:",
      description: `أن نقود الاقتصاد الدائري في صناعة خردة الألومنيوم في منطقة الشرق الأوسط وشمال أفريقيا، من خلال الحد من الفاقد، وتعزيز الاستدامة، وتشجيع المشاركة الفعالة في الحفاظ على البيئة ونمو الاقتصاد.`,
    },
  },
  balance: {
    myBalance: "الرصيد",
    quantity: "الكمية:",
    noData: "ليس لديك طلبات",
    totalQuantity: "الكمية الكلية",
    totalPrice: "السعر الكلي",
    price: "سعر الشراء:",
    date: "تاريخ الشراء:",
    kg: "كجم",
    totalOfferPrice: "إجمالي سعر العرض",
    totalProfit: "إجمالي الربح",
    totalPurchasePrice: "إجمالي سعر الشراء",
    egp: "جنيه",
    profitPercentage: "نسبة الربح",
  },
  buyers: {
    title: "العروض",
    quantity: "الكمية:",
    price: "السعر",
    requestDate: "تاريخ الطلب:",
    noData: "ليس لديك عروض",
    weight: "الكمية:",
    moreOffers: "كل عروض",
    highestOffer: "أعلى عرض",
    lowestOffer: "أقل عرض",
    pricePerKilo: "السعر لكل كيلو",
    afterCommission: "السعر بعد العمولة",
    totalPrice: "السعر الكلي",
  },
  pendingOrders: {
    title: "الطلبات المعلقة",
    pending: "الطلبات المعلقة",
    weight: "الكمية:",
    noData: "ليس لديك طلبات معلقة",
    paymentMethod: "طريقة الدفع:",
    allOrders: "الكل",
    cash: "كاش",
    credit: "بطاقة الائتمان",
    kg: "كجم",
    purchasePrice: "سعر الشراء:",
    totalPrice: "إجمالي السعر:",
    egp: "جنيه",
  },
  pendingWithdrawals: {
    title: "عمليات السحب المعلقة",
    category: "النوع",
    quantity: "الكمية المباعة",
    kg: "كجم",
    offeredPricePerKilo: "السعر المعروض/كجم",
    offerDate: "تاريخ العرض",
    sellingDate: "تاريخ البيع",
    commission: "العمولة",
    managementFees: "المصاريف الادارية",
    Price: "السعر",
    totalAfterCommission: "السعر الكلي",
    egp: "جنيه",
    noData: "لا توجد عمليات سحب معلقة",
  },
  notificationModal: {
    enterQuantity: "حدد الكمية",
    requiredQuantity: "من فضلك حدد الكمية",
    correctQuantity: "من فضلك حدد كمية صحيحة",
    accept: "قبول",
    reject: "رفض",
    rejectMsg: "أنت على وشك رفض العرض!",
    acceptOffer: "قبول العرض",
    rejectOffer: "رفض العرض",
    profit: "قيمة الربح",
    profitPercentage: "نسبة الربح",
    commission: "قيمة العمولة",
    commissionPercentage: "نسبة العمولة",
    storage: "قيمة التخزين",
    storagePercentage: "نسبة التخزين",
    egp: "جنيه",
    priceAfterCommissionDeduction: "سعر البيع بعد خصم العمولة",
    sellItem: "بيع المنتج",
    purchasePrice: "سعر الشراء",
    purchaseDate: "تاريخ الشراء",
    chooseCollectionType:
      "من فضلك اختر طريقة تحصيل إجمالي المبلغ بعد خصم العمولة إما نقديا أو عن طريق استخدام المتجر",
    message:
      "في حال البيع قبل مدة التخزين المتفق عليها، قد يتم تطبيق خصم بنسبة 3% إلى 7%",
  },
  profileModal: {
    noGroups: "لم يتم الانضمام إلى مجموعات",
    myGroups: "مجموعاتي",
  },
  bidders: {
    actualBudget: "الميزانية الكلية",
    availableBudget: "الميزانية المتاحة",
    empty: "الصفحة فارغة!",
    checkLater: "يرجى التحقق لاحقًا من إضافة مزادات!",
    activeAuctions: "المزادات المتاحة",
    allAuctions: "كل المزادات",
    minBidding: "الحد الأدنى للمزاد",
    start: "البداية:",
    started: "البداية:",
    am: "ص",
    pm: "م",
    lastPrice: "آخر سعر",
    auctionPrice: "سعر المزاد",
    endTime: "سينتهي بعد",
    viewDetails: "عرض التفاصيل",
    join: "إنضم",
    deniedAccess:
      "يجب عليك الإنضمام لمجموعه ما لكي تشارك في المزادات الخاصه بنا!",
    ok: "حسناً",
    backToAuctions: "العودة للمزادات",
    liveAuctions: "المزادات الحالية",
    upcomingAuctions: "المزادات القادمة",
    oldAuctions: "المزادات السابقه الخاصه بي",
    searchPlaceholder: "ابحث باسم المزاد أو تاريخ البداية..",
    noResults: "لم يتم العثور على نتائج!",
    auctionDetails: "تفاصيل المزاد",
    incrementValue: "معدل الزيادة للقفزه الواحده",
    allAuctionItems: "كل منتجات المزاد:",
    itemQuantity: "الكمية:",
    itemWeight: "الوزن:",
    seeAuctionGroups: "رؤية مجموعات المزاد",
    emptyChatMsg: "كن أول من يفوز بالمزاد",
    writeHere: "اكتب هنا",
    allGroups: "كل المجموعات",
    selectGroupToJoinAuction: "اختر إحدى مجموعاتك للانضمام إلى هذا المزاد!",
    groupName: "اسم المجموعة",
    joinAuctionRequiredGroupMsg:
      "يجب عليك اختيار المجموعة المراد الإنضمام معها للحصول على المزاد",
    supervisorJoinedSameAuctionWithDifferentGroup:
      "عفوا, أنت مشارك بالفعل في هذا المزاد بجروب آخر",
    chat: {
      you: "أنت",
      emptyState: "من فضلك , أدخل سعر المزاد",
      invalidPrice: "من فضلك , أدخل سعر صحيح للمزاد",
      insufficientBudget:
        "ميزانية مجموعتك لم تعد كافية للمتابعة، يمكنك زيادتها بعد موافقة الأعضاء",
      congratulations: "تهانينا!",
      winnerMsg: "عمل عظيم! أنتم الفائزون بالمزاد.",
      winnerOfAuction: "هو الفائز بالمزاد",
      reachedMarketPrice: "لقد وصل سعر المزايدة إلى سعر السوق",
    },
    maxQuantityPerUser: "أعلى كمية للفرد",
    participate: "مشاركة",
  },
  luckyHours: {
    luckyHours: "أسعار مخفضة",
    noOffers: "لا توجد عروض متاحة في هذا الوقت. الرجاء المحاولة لاحقا!",
    luckyHoursItems: "عناصر الأسعار المخفضة",
    offer: "عرض",
  },
  storeItems: {
    description: "الوصف",
    enterQuantity: "ادخل الكمية",
    buy: "شراء",
    requiredQuantityMsg: "من فضلك, أدخل الكمية",
    notAvailableQuantityMsg: "الكمية غير متاحة ف المتجر",
    minQuantityMsg: "الحد الأدنى للشراء 1",
    totalPrice: "السعر الكلى",
    emptyState:
      "!لا يوجد حاليا أي منتجات متوفرة في المتجر. الرجاء المحاولة مرة أخرى لاحقا",
    confirmMsg: {
      1: "أنت على وشك دفع",
      pay: "و سيتم دفع",
      recieve: "و سيتم استلام",
      3: "نقديا عند الاستلام",
    },
    confirm: "تأكيد",
    backToHome: "عودة للرئيسية",
    exchange: "استبدال",
    selectPaymentMethod: "اختر وسيلة الدفع",
    paymentMethod: "وسيلة الدفع",
    feesAdded: "*2.5% ضرائب مضافة",
    purchaseAmount: "قيمة الشراء ستكون",
    totalPurchasePrice: "سعر الشراء",
    item: "منتج",
    exchangePriceDiffMsg: {
      recieve: "سوف يصلك",
      pay: "يجب عليك دفع",
      2: "قيمة الفرق في السعر وهي",
      3: "كاش عند الاستلام",
    },
  },
  groups: {
    groupBudget: "ميزانية المجموعة",
    groupMembers: "أعضاء المجموعة",
    you: "أنت",
    supervisor: "مشرف",
    increaseBudgetBtn: "طلب زيادة الميزانية",
    increaseBudget: {
      requiredIncrement: "من فضلك, أدخل قيمة الزياده لكل عضو داخل الجروب",
      invalidIncrement: "من فضلك, أدخل قيمة الزياده الصحيحة",
      increaseBudgetFor: "طلب زيادة ميزانية",
      incrementValuePerMember: "قيمة الزيادة لكل عضو",
      sendIncrementRequest: "إرسال طلب الزيادة",
      increaseBudgetPlaceholder: "أدخل قيمة الزيادة",
    },
    lastRequestState: "حالة آخر طلب",
    Pending: "قيد المراجعة",
    Accepted: "تمت الموافقة",
    Rejected: "تم الرفض",
    requestForMember: {
      requestedIncrementAmount: "قيمة الزيادة المطلوبة",
      confirmAccept: "هل أنت متأكد من أنك تريد قبول الطلب؟",
      confirmReject: "هل أنت متأكد من أنك تريد رفض الطلب؟",
      accept: "قبول",
      reject: "رفض",
      cancel: "إلغاء",
      egp: "جنيه",
    },
  },
  auctionRequests: {
    drawerTitle: "طلبات المزاد",
    noData: "ليس لديك طلبات حتى الآن!",
    maxQuantityPerUser: "الحد الأقصى للكمية للمستخدم",
    kg: "كجم",
    accept: "قبول",
    reject: "رفض",
    confirm: "تأكيد",
    quantity: "الكمية",
    enterQuantity: "أدخل الكمية التي تريد استخدامها في المزاد!",
    requiredQuantityMsg: "من فضلك, أدخل الكمية",
    invalidQuantityMsg: "من فضلك, أدخل كمية صحيحة",
    quantityLessThanZeroMsg: "أقل قيمة يجب أن تكون أكبر من الصفر",
    insufficientBalanceMsg: "رصيدك من هذا النوع غير كافي",
    maxQuantityPerUserMsg: "أعلى قيمة يجب أن تكون أقل من أو تساوي",
    selectPaymentMethod: "إختر طريقة الدفع",
    paymentMethod: "طريقة الدفع",
    auctionPrice: "سعر المزاد",
    auctionQuantity: "كمية المزاد",
    pay: "ادفع",
    requiredPaymentMethod: "من فضلك, اختر طريقة دفع",
    confirmReject: "هل أنت متأكد أنك تريد إلغاء هذا الطلب؟",
    noBalanceMsg:
      "نأسف لعدم وجود رصيد لديك من هذا النوع. يمكنك الدخول في المزاد للحصول على الرصيد منه.",
    request: "طلبات",
    myAuctions: "مزاداتي",
    auctionStatus: "حالة المزاد",
    participatedAmount: "كمية المشاركات",
  },
  buyAndSupply: {
    title: "شراء وتوريد",
    buy: "شراء",
    supply: "توريد",
    pageIsEmpty: "الصفحة فارغة!",
    checkItemsLater: "يرجى التحقق لاحقًا من العناصر المضافة",
    checkTypesLater: "يرجى التحقق لاحقًا من الأنواع المضافة",
    checkBalanceLater: "يرجى التحقق لاحقًا من رصيدك",
    availableInStore: "متاح في المخزن",
    lePerKg: "جنيه / كجم",
    AEDPerKg: "درهم / كجم",
    note: "note in arabic",
    buyItem: "شراء المنتج",
    enterQuantityMsg: "أدخل الكمية التي تريد شرائها",
    quantity: "الكمية",
    paymentMethod: "طريقة الدفع",
    requiredPaymentMethod: "من فضلك اختر طريقة دفع",
    balance: "رصيد",
    yourBalanceFrom: "رصيدك من",
    kilo: "كيلو",
    egp: "جنيه",
    aed: "درهم اماراتي",
    requiredQuantityMsg: "من فضلك أدخل الكمية",
    invalidQuantityMsg: "من فضلك أدخل كمية صحيحة",
    exceedingAvailableQuantityMsg: "من فضلك أدخل كمية صحيحة",
    totalPrice: "إجمالي السعر",
    wantedQuantity: "الكمية المطلوبة",
    durationToRecieve: "  أدخل الكمية و اختر مدة استلام أموالك",
    selectDuration: "اختر المدة لتلقي الأموال",
    next: "التالي",
    requiredDuration: "من فضلك, اختر مدة",
    kg: "كجم",
    after: "بعد",
    day: "يوم",
    days: "أيام",
    totalPriceBuy: "السعر الإجمالي",
    price: "السعر",
    pendingOrders: "الطلبات المعلقة",
    emptyPendingOrders: "ليس لديك طلبات معلقة!",
  },
  invoice: {
    invoice: "فاتورة",
    itemName: "اسم العنصر",
    itemType: "اسم النوع",
    paymentMethod: "طريقة الدفع",
    paymobFees: "رسوم باي موب",
    quantity: "الكمية",
    unitPrice: "سعر الوحدة",
    totalPrice: "السعر الكلي",
    back: "رجوع",
    proceedToCheckout: "مواصلة الشراء",
    buyItem: "تأكيد الشراء",
    kioskFees: "رسوم الكشك",
  },
  merchant: {
    description: "بيع الأنواع بكميات كبيرة، خاصة من قبل التجار",
    merchantID: "الرقم التعريفى للتاجر",
    sell: "بيع",
    pricePerKilo: "السعر بالكيلو",
    LEPerKG: "جنيه / كجم",
    enterWeight: "ادخل الوزن",
    notEnoughBalanceMSG: "رصيدك ليس كافي",
    noBalanceMSG: "عذرا، ليس لديك رصيد ",
    ok: "تم",
  },
  partnership: {
    description: "مدفوعات رقمية آمنة وسلسة وفورية",
  },
  rent: {
    header: "مخزن للتأجير",
    description:
      "نحن نقدم مساحات مخازن  للإيجار تتراوح من 10 إلى 1000 متر مربع مصممة لتناسب احتياجاتك بالضبط.",
  },

  received: {
    noData: "لم تستلم أي تأكيد بعد!",
    notificationModal: {
      accept: "قبول",
      reject: "رفض",
      cancel: "إلغاء",
      yes: "نعم",
      no: "لا",
      confirmAcceptTitle: "تأكيد القبول",
      confirmRejectTitle: "تأكيد الرفض",
      confirmAcceptMessage: "هل أنت متأكد أنك تريد القبول؟",
      confirmRejectMessage: "هل أنت متأكد أنك تريد الرفض؟",
    },
  },
  idModal: {
    msg: "من فضلك أدخل الرقم القومي.",
    title: "الرقم القومي.",
    placeholder: "أدخل الرقم القومي",
    numberOnly: "أرقام فقط.",
    validID: "من فضلك أدخل رقم قومي صحيح.",
  },
  emailModal: {
    msg: "يرجى إدخال عنوان بريدك الإلكتروني",
    title: "عنوان البريد الإلكتروني",
    required: "عنوان البريد الإلكتروني مطلوب",
    invalidEmail: "يرجى إدخال بريد إلكتروني صالح",
    placeholder: "أدخل عنوان بريدك الإلكتروني",
  },
  cashoutConfirmation: {
    title: "تأكيد السحب",
    recieved: "تم الاستلام",
    notRecieved: "لم يتم الاستلام",
  },
};
